import axios from 'axios';

// Use absolute API URL if set, otherwise fallback to relative '/api'
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api'
});

export const login = (credentials) => api.post('/auth/login', credentials);
export const getMembers = (token) =>
  api.get('/members', { headers: { Authorization: `Bearer ${token}` }});
export const getMember = (id, token) =>
  api.get(`/members/${id}`, { headers: { Authorization: `Bearer ${token}` }});
export const createMember = (data, token) =>
  api.post('/members', data, { headers: { Authorization: `Bearer ${token}` }});
export const updateMember = (id, data, token) =>
  api.put(`/members/${id}`, data, { headers: { Authorization: `Bearer ${token}` }});
export const deleteMember = (id, token) =>
  api.delete(`/members/${id}`, { headers: { Authorization: `Bearer ${token}` }});

export default api;
